export const SEARCH_FIELD_KEYS = ['origin', 'destination', 'date', 'nights', 'guests'] as const;
